import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalComponent } from '../../../lib/services/modal.service';
import { BillingService } from '../../../lib/services/billingService';
import { take } from 'rxjs/operators';
import { PlatformLocation } from '@angular/common';

enum planIntervals {
  quarterly = 0,
  yearly = 1,
}

enum planTypes {
  standard = 0,
  pro = 1,
}

const AllPlansSorted = {
  yearly: {
    standard: null,
    pro: null,
  },
  quarterly: {
    standard: null,
    pro: null,
  },
};

interface ActivePlanInterface {
  interval: planIntervals;
  plan: planTypes;
}

@Component({
  selector: 'mj-select-plan',
  templateUrl: './select-plan.component.html',
  styleUrls: ['./select-plan.component.scss'],
  providers: [BillingService],
})
export class SelectPlanComponent extends ModalComponent implements OnInit {
  selectedInterval = planIntervals.quarterly;
  loading: boolean;
  userSubs;

  activePlan: ActivePlanInterface = { interval: null, plan: null };
  allSubscriptions = AllPlansSorted;

  @Output() onPlanSelected = new EventEmitter();
  @Input() unpaid;

  constructor(
    private billingService: BillingService,
    location: PlatformLocation
  ) {
    super();

    this.data.pipe(take(1)).subscribe((data: { userSubs: {} }) => {
      this.userSubs = data.userSubs;
      if (data.userSubs) {
        this.assignActivePlans(data.userSubs[0]);
      }
    });

    location.onPopState(() => {
      history.go(1);
      this.resolve.next(null);
    });
  }

  ngOnInit(): void {
    this.loading = true;

    this.billingService
      .fetchMojobBillingPlans()
      .pipe(take(1))
      .subscribe(allSubs => {
        this.sortSubscriptions(allSubs.data);
      });
  }

  toggleInterval() {
    this.selectedInterval =
      this.selectedInterval === planIntervals.quarterly
        ? planIntervals.yearly
        : planIntervals.quarterly;
  }

  sortSubscriptions(subs) {
    // sorting all available subscriptions for easier management
    subs.forEach(sub => {
      if (sub.interval === 'month') {
        if (sub.tiers[0].flat_amount) {
          this.allSubscriptions.quarterly.pro = sub;
        } else {
          this.allSubscriptions.quarterly.standard = sub;
        }
      } else {
        if (sub.tiers[0].flat_amount) {
          this.allSubscriptions.yearly.pro = sub;
        } else {
          this.allSubscriptions.yearly.standard = sub;
        }
      }
    });

    this.loading = false;
  }

  selectPlan(type) {
    this.loading = true;

    const interval = planIntervals[this.selectedInterval];
    const plan = planTypes[type];
    const unitID = localStorage.getItem('unit_id');

    const request = {
      plan_id: this.allSubscriptions[interval][plan].id,
      subscription_id: this.userSubs ? this.userSubs[0].id : '',
      quantity: 1,
    };

    if (!this.unpaid) {
      this.billingService
        .activateSubscription(unitID, request)
        .pipe(take(1))
        .subscribe(sub => {
          this.loading = false;
          this.assignActivePlans(sub);
        });
    } else {
      this.onPlanSelected.emit(this.allSubscriptions[interval][plan]);
    }
  }

  assignActivePlans(sub) {
    if (sub) {
      this.activePlan = {
        interval:
          sub.plan.interval === 'year'
            ? planIntervals.yearly
            : planIntervals.quarterly,
        plan: sub.plan.tiers[0].flat_amount
          ? planTypes.pro
          : planTypes.standard,
      };

      this.resolve.next([sub]);
    }
  }

  closeModal() {
    this.resolve.next(null);
  }
}
